<template>
  <div class="home">
<div class="works">
<div class="works-ban">
	
		<p> 
<span>購物車 </span>  →   <span>結帳</span>  →  <span class="acts">訂單完成</span>  </p>
	</div>
	<div class="home-ct">
<div class="rider">
<div class="l1">
	<div class="ic"> <img src="../../assets/right2.png"></div>
	您已成功支付
</div>
<div class="l2">
	<router-link to="/product/list">
	<div class="h-button cart-but">更多產品</div>
	</router-link>
</div>
</div>

		</div>
</div>
  
    </div>
</template>
<script>



export default {

  data() {
    return {
	id:'',
    data:'',
	channel_id:0
    };
  }, 
 mounted() {
	 
this.id = this.$route.query.id;
		this.sandMate();
		this.sandCase();
		},methods: {
		 scroll(scrollData){
		                console.log(scrollData)
		            },
			        switchCol(col){
			            this.col = col
			            console.log(this.col)
			      },
			      loadmore(index){
			            this.data = this.data.concat(this.data)
			      },

			sandMate(){
			
			this.$axios({
			  method: "post",
			  url: "service.php?action=index_newsDetail",
			  data: {id:this.id},  
			}).then((res) => {
				let data=res.data;
						
				if(data.code==1){
						
					this.data=data.data;
					this.channel_id=data.data.channel_id
					
				}
			 
			});
			
			
			
			},sandCase(){
				this.$axios({
				  method: "post",
				  url: "/api/noticelist",
				  data: {page:1},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==200){
						
						this.notice=data.data;
						
						
					
					}
				 
				});
			},buff(item){
				this.channel_id=item
				this.sandMate()
			}
		}
};
</script>
<style lang="scss" scoped>

.works{
	.rider{
		background-color: #F9F9F9;
		margin: 50px 0;
		padding: 60px;
		text-align: center;
		.l1{
			display: flex;
			justify-content: center;
			font-size: 30px;
			align-items: center;
			font-weight: bolder;
			.ic{
				margin-right: 20px;
			}
		}
		.l2{
			text-align: center;
			margin-top: 100px;
			.h-button{
				margin: 0 auto;
				width: 150px;
				text-align: center;
				cursor: pointer;	
				padding: 0 50px;
				height: 50px;
				line-height: 50px;
				background: #000;
				color: #FFFFFF;
			}
			.h-button:hover{
				background-color: #333333;
			}
		}
	}

	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}

}

</style>